"use strict"

angular.module("core")
.constant("SHIPPING_RATE_METHOD_PER_ORDER", "per order")
.constant("SHIPPING_RATE_METHOD_PER_AMOUNT", "per amount")
.constant("SHIPPING_RATE_METHOD_PER_REGION_AND_WEIGHT", "per region weight")



//////////////////
// WEBPACK FOOTER
// ./core/shipping-rate/shipping-rate.constant.js
// module id = 391
// module chunks = 0